<template>
  <v-dialog
    :value='dialog'
    persistent
    max-width='290'
  >
    <v-card>
      <v-card-title class='headline'>Error</v-card-title>
      <v-card-text>
        {{message}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
        depressed
          color='green darken-1'
          text
          @click='update(false)'
        >Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    message: String,
    update: Function,
  },
};
</script>

<style>
</style>
